// extracted by mini-css-extract-plugin
export default {"wrapper":"modal_wrapper__7QG-f","open":"modal_open__xw3-G","modal":"modal_modal__MnG0H","close":"modal_close__agaYw"};